module.exports = __webpack_public_path__ + "970309e97095bfc920063c38204a3dd1.png";